import { gql } from '@apollo/client';

export const ADD_PRODUCT_TIP = gql`
  mutation addProductTip($product_id: Int!, $sku: String!, $email: String!) {
    addProductTip(input: { product_id: $product_id, sku: $sku, email: $email }) {
      code
      message
      content
    }
  }
`;

export default {
  addProductTipMutation: ADD_PRODUCT_TIP,
};
